export default __webpack_public_path__ + "static/sponsored-badge-b441723e19d427081d0518a1aa4ac814.svg";